import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type TravelCashFundBalanceQueryVariables = Types.Exact<{
  eventId: Types.Scalars['String'];
}>;

export type TravelCashFundBalanceQuery = {
  __typename?: 'Query';
  travelCashFundBalance: {
    __typename?: 'TravelCashFundBalance';
    currency?: string | null;
    walletBalanceMinorUnits?: number | null;
    cashFundBalanceMinorUnits?: number | null;
    totalSpendableMinorUnits?: number | null;
  };
};

export const TravelCashFundBalanceDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TravelCashFundBalance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'travelCashFundBalance' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'walletBalanceMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cashFundBalanceMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalSpendableMinorUnits' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useTravelCashFundBalanceQuery__
 *
 * To run a query within a React component, call `useTravelCashFundBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelCashFundBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelCashFundBalanceQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useTravelCashFundBalanceQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TravelCashFundBalanceQuery, TravelCashFundBalanceQueryVariables>) {
  return ApolloReactHooks.useQuery<TravelCashFundBalanceQuery, TravelCashFundBalanceQueryVariables>(TravelCashFundBalanceDocument, baseOptions);
}
export function useTravelCashFundBalanceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TravelCashFundBalanceQuery, TravelCashFundBalanceQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<TravelCashFundBalanceQuery, TravelCashFundBalanceQueryVariables>(TravelCashFundBalanceDocument, baseOptions);
}
export type TravelCashFundBalanceQueryHookResult = ReturnType<typeof useTravelCashFundBalanceQuery>;
export type TravelCashFundBalanceLazyQueryHookResult = ReturnType<typeof useTravelCashFundBalanceLazyQuery>;
export type TravelCashFundBalanceQueryResult = Apollo.QueryResult<TravelCashFundBalanceQuery, TravelCashFundBalanceQueryVariables>;
